"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sup = exports.ActiveTabContainer = exports.sharedTabsStyles = exports.Tab = exports.TabsContainer = exports.Tabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Join = require("../Join");

var _Typography = require("../Typography");

var _helpers = require("../../helpers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    overflow-y: hidden;\n    overflow-x: scroll;\n    -webkit-overflow-scrolling: touch;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 0 ", "px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** A tabbar navigation component */
var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setActiveTab", function (activeTabIndex) {
      _this.setState({
        activeTabIndex: activeTabIndex
      });

      if (_this.props.onChange) {
        _this.props.onChange({
          tabIndex: activeTabIndex,
          name: _this.props.children[activeTabIndex].props.name,
          data: _this.props.children[activeTabIndex].props.data
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "containerRef", null);

    _defineProperty(_assertThisInitialized(_this), "activeTabRef", null);

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      if (!_this.props.autoScroll || !_this.containerRef || !_this.activeTabRef) {
        return;
      }

      var contentWidth = _this.containerRef.scrollWidth;
      var boxWidth = _this.containerRef.offsetWidth;

      if (boxWidth >= contentWidth) {
        return;
      }

      var containerRect = _this.containerRef.getBoundingClientRect();

      var activeTabRect = _this.activeTabRef.getBoundingClientRect();

      var activeTabOffset = activeTabRect.left - containerRect.left;
      var desiredActiveTabOffset = containerRect.width / 2 - activeTabRect.width / 2;
      var offsetDiff = activeTabOffset - desiredActiveTabOffset;
      var currentScroll = _this.containerRef.scrollLeft;
      var desiredScroll = currentScroll + offsetDiff;

      _this.containerRef.scrollTo({
        left: desiredScroll
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTab", function (tab, index) {
      if (!tab) {
        return false;
      }

      var name = tab.props.name;
      return _this.state.activeTabIndex === index ? _this.props.transformTabBtn(_react.default.createElement(ActiveTabButton, {
        key: index
      }, name), index, _this.props) : _this.props.transformTabBtn(_react.default.createElement(TabButton, {
        key: index,
        onClick: function onClick() {
          return _this.setActiveTab(index);
        }
      }, name), index, _this.props);
    });

    var _activeTabIndex = props.initialTabIndex || _this.props.children.findIndex(function (tab) {
      return !!tab;
    });

    _this.state = {
      activeTabIndex: _activeTabIndex
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleScroll);
      this.handleScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? [] : _this$props$children,
          separator = _this$props.separator;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(TabsContainer, {
        scrollRef: function scrollRef(ref) {
          return _this2.containerRef = ref;
        },
        justifyContent: this.props.justifyContent
      }, _react.default.createElement(_Join.Join, {
        separator: separator
      }, children.map(this.renderTab))), _react.default.createElement(_Box.Box, {
        pt: 3
      }, children[this.state.activeTabIndex]));
    }
  }]);

  return Tabs;
}(_react.default.Component);

exports.Tabs = Tabs;

_defineProperty(Tabs, "defaultProps", {
  justifyContent: "left",
  transformTabBtn: function transformTabBtn(Button) {
    return Button;
  },
  separator: _react.default.createElement(_Box.Box, {
    ml: 2
  })
});

Tabs.displayName = "Tabs";

/** A container for the tab bar */
var TabsContainer = function TabsContainer(_ref) {
  var scrollRef = _ref.scrollRef,
      props = _objectWithoutProperties(_ref, ["scrollRef"]);

  return _react.default.createElement(TabsOuterContainer, null, _react.default.createElement(TabsScrollContainer, _extends({
    mb: 0.5,
    width: "100%"
  }, props, {
    ref: scrollRef
  }), _react.default.createElement(TabsPaddingContainer, null, props.children)));
};

exports.TabsContainer = TabsContainer;
TabsContainer.displayName = "TabsContainer";

/** An individual tab */
var Tab =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Tab, _React$Component2);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tab).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return Tab;
}(_react.default.Component);

exports.Tab = Tab;
Tab.displayName = "Tab";

var TabButton = function TabButton(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react.default.createElement(TabContainer, props, _react.default.createElement(_Typography.Sans, {
    size: "3t",
    weight: "medium",
    color: "black30"
  }, children));
};

TabButton.displayName = "TabButton";

var ActiveTabButton = function ActiveTabButton(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement(ActiveTabContainer, null, _react.default.createElement(_Typography.Sans, {
    size: "3t",
    weight: "medium"
  }, children));
};

ActiveTabButton.displayName = "ActiveTabButton";

/** Sharable tab styles  */
var sharedTabsStyles = {
  tabContainer: (0, _styledComponents.css)(["cursor:pointer;padding-bottom:13px;white-space:nowrap;"]),
  activeTabContainer: (0, _styledComponents.css)(["pointer-events:none;padding-bottom:13px;white-space:nowrap;border-bottom:1px solid ", ";"], (0, _helpers.color)("black60"))
};
exports.sharedTabsStyles = sharedTabsStyles;
var TabsOuterContainer = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Tabs__TabsOuterContainer",
  componentId: "sc-1kalvjm-0"
})(["width:100%;border-bottom:1px solid ", ";position:relative;top:-1px;> div{position:relative;top:1px;}"], (0, _helpers.color)("black10"));
var TabsPaddingContainer = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Tabs__TabsPaddingContainer",
  componentId: "sc-1kalvjm-1"
})(["", ";"], _helpers.media.xs(_templateObject(), (0, _helpers.space)(2)));
var TabsScrollContainer = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Tabs__TabsScrollContainer",
  componentId: "sc-1kalvjm-2"
})(["", ";margin-bottom:0;"], _helpers.media.xs(_templateObject2()));

var TabContainer = _styledComponents.default.div.withConfig({
  displayName: "Tabs__TabContainer",
  componentId: "sc-1kalvjm-3"
})(["", ";"], sharedTabsStyles.tabContainer);
/** The active container */


var ActiveTabContainer = _styledComponents.default.div.withConfig({
  displayName: "Tabs__ActiveTabContainer",
  componentId: "sc-1kalvjm-4"
})(["", ";"], sharedTabsStyles.activeTabContainer);

exports.ActiveTabContainer = ActiveTabContainer;

var SupWrapper = _styledComponents.default.sup.withConfig({
  displayName: "Tabs__SupWrapper",
  componentId: "sc-1kalvjm-5"
})(["margin-left:2px;"]);
/** Embeddable sup container */


var Sup = function Sup(_ref4) {
  var children = _ref4.children;
  return _react.default.createElement(SupWrapper, null, _react.default.createElement(_Typography.Sans, {
    size: "1",
    weight: "medium",
    display: "inline"
  }, children));
};

exports.Sup = Sup;
Sup.displayName = "Sup";
//# sourceMappingURL=Tabs.js.map